module.exports = __webpack_public_path__ + "static/media/homeIcon.979c4dfb.svg";